export default {
  modalTitle: {
    en: 'Your invitation has been sent',
  },
  modalButtonTitle: {
    en: 'Ok',
  },
}
